import { isVersionOlderOrEqual } from "Global/Base/Utils/versionUtils";
import { ICommunicationManager } from "../ICommunicationManager";
import { CommunicationManager } from "./CommunicationManager";
import { LegacyUpTo2101CommunicationManager } from "./LegacyUpTo2101CommunicationManager";

export function defaultFactory(webServiceUrl: string, webServiceVersion?: string): ICommunicationManager {
    return isVersionOlderOrEqual(webServiceVersion, "21.01") ?
        new LegacyUpTo2101CommunicationManager(webServiceUrl)
        : new CommunicationManager(webServiceUrl);
}
